import {  Alert } from 'projects/lib-components/src/public_api';
import { ServerData } from './serverData';
import { TranslationData } from './translationData';


export class TranslationModel {
  public Action: string;
  public Translation: TranslationData;
  public LstTranslations: Array<TranslationData>;
  public LstAlert: Array<Alert>;
  public NbPages: number;
  public NumPage: number;  
  public StrNbLignesAffiche: string; 
  public IsDevMachine: boolean;
  public ConnectStringForIntranet: string;
  //partie transfert des traductions
  public ServerSource: ServerData;
  public ServerDestination: ServerData;
  public LstTraductionsFiltre: TranslationData[];
  public StrToSearch: string;
  public PcCanDeleteTrad: boolean;
  public RoleUser: string;
}


